import { createContext } from "react";

export const AlternateAliasContext = createContext({
    aliasModule: {
        isOpen: false,
        displayName: null,
        upn: null,
        dn: null,
        data: null,
        searchResults: null
    },
    setAliasModule: () => ({})
});